import { render } from "./AddToJob.vue?vue&type=template&id=0228ad30"
import script from "./AddToJob.vue?vue&type=script&lang=js"
export * from "./AddToJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__